module.exports = __webpack_public_path__ + "img/admin-with-cogwheels.5933c6ba.svg";